<template>
  <div class="fts-classification" :data-sync="syncState" :data-form-load="isFormLoading ? 'loading' : 'loaded'">
    <fts-form
      :vector-id="vectorId"
      :activity-id="activityId"
      :form="form"
      :form-data="formData"
      :validator="$v.formData"
      :context="context"
      :view="view"
      :share-form="shareForm"
      :username="username"
      :comfort-design="comfortDesign"
      :form-settings="formSettings"
      :form-element-overflow-auto="formElementOverflowAuto"
      :form-element-disabled="isFormLoading"
      :design-mode="!loading && isCompatibleDesignMode && !isFallbackDesignMode"
      :shortcut-options="availableInformation"
      :shortcut-selected-options="classificationInformation"
      :shortcut-elements="shortcutElements"
      :without-information="isFormWithoutInformation"
      @eventTriggered="triggerEvent"
      @design:change="updateDesign"
      v-if="!comment.attention"
    />

    <div
      class="form-hint-group form-hint-action-wrapper"
      v-if="!loading && isCompatibleDesignMode && isFallbackDesignMode"
    >
      <router-link :to="designRoute" target="_blank" class="form-hint-action">
        <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" fixed-width class="form-hint-action-icon" />Click to design form
      </router-link>
    </div>

    <fts-comment
      :vector-id="vectorId"
      :comment="comment"
      :mention="commentMention"
      class="classification-comment"
      v-if="commentSection && !loading && !view"
    />
  </div>
</template>
<script>
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import { classificationStore } from '../store/classificationStore';
import { clientStore } from '../store/clientStore';
import { store as canvasDesignStore } from '../store/canvasDesignStore';
import canvasDesign from '../commons/canvasDesign';
import commons from '../commons/commons';
import formDesign from '../commons/formDesign';

import FTSComment from './FTSComment';
import FTSForm from './FTSForm';
import FTSFormLayouter from '../design/FTSFormLayouter';

export default {
  props: {
    locusId: [String, Number],
    locusIds: String,
    vectorId: [String, Number],
    activityId: String,
    activity: String,
    users: Array,
    currentUsername: String,
    view: Boolean,
    shareForm: Boolean,
    loading: Boolean,
    submitting: Boolean,
    synchronizing: Boolean,
    context: Object,
    username: String,
    viewData: Object,
    comfortDesign: Boolean,
    formElementOverflowAuto: Boolean,
    formValidationError: Function,
    designMode: Boolean,
    formSettings: Object,
    /* classification section */
    commentSection: {
      type: Boolean,
      default: true,
    },
    comment: {
      type: Object,
      default: () => ({}),
    },
    commentMention: {
      type: Boolean,
      default: true,
    }
  },
  data: () => ({
    polling: null,
    selectedActivity: null,
    formChanged: false
  }),
  validations() {
    let formData = {};
    let elements = commons.getVisibleElements(null, this.form);
    /* temp for visibilityScript */
    elements = elements.filter(x => commons.formElementVisibility(x, this.formData));
    /* end */
    formData = commons.getFormValidators(elements, null, this.formData);
    return { formData };
  },
  store: classificationStore,
  components: {
    "fts-comment": FTSComment,
    "fts-form": FTSForm
  },
  computed: {
    formData: {
      get: function () {
        if(this.viewData)
          return this.viewData.formData;
        return this.$store.state.formData;
      },
    },
    form: {
      get: function () {
        if(this.viewData)
          return this.viewData.form;
        return this.$store.state.form;
      },
    },
    sync() {
      return this.$store.state.needSync;
    },
    syncState() {
      if (this.$store.state.needSync && !this.viewData) {
        if (this.$store.state.synchronizing)
          return "syncing";
        else if (this.$store.state.syncError)
          return "resync";
        else
          return "synced";
      }
    },
    isFormLoading() {
      const synchronizing = this.$store.state.synchronizing;
      this.$emit("update:synchronizing", synchronizing);
      return synchronizing;
    },
    designRoute() {
      return clientStore.getters.workspaceBuilder ?
        { name: 'builder' } :
        { name: 'studio', query: { id: commons.encodeids(this.vectorId)}};
    },
    isCompatibleDesignMode() {
      if (!this.designMode || this.activityId == "manage")
        return false;

      return true;
    },
    isFallbackDesignMode() {
      if (!!this.syncState)
        return true;

      return this.form && this.form.rows.some(row =>
        row.items && row.items.some(item =>
          item.type == 15 || ['section', 'table', 'list', 'empty', 'button', 'custom'].includes(item.input)
        )
      );
    },
    isFormWithoutInformation() {
      return this.form && this.form.rows ? !formDesign.isFormContainsInformation(this.form.rows) : true;
    },
    canvasInformation() {
      if (this.designMode)
        return canvasDesignStore.getters.canvasInformation;
    },
    classificationInformation() {
      if (this.designMode && this.form && this.form.rows)
        return commons.classificationInformation(this.form.rows, this.canvasInformation);
    },
    availableInformation() {
      if (this.designMode)
        return [...this.canvasInformation].filter((x) =>
          !this.classificationInformation.some((y) => y.id == x.id)
        );
    },
    shortcutElements() {
      return [formDesign.Element.Content, formDesign.Element.Image];
    }
  },
  methods: {
    triggerEvent({ eventName, eventPayload }) {
      classificationStore.dispatch('eventTriggered', {
        activity: this.selectedActivity,
        eventName: eventName,
        eventPayload: eventPayload
      });
    },
    addToForm(cartItems) {
      if (this.formData[cartItems.fields[0].fieldName] == null) {
        Vue.set(this.formData, cartItems.fields[0].fieldName, []);
      }
      //find form field,
      let rows = this.formData[cartItems.fields[0].fieldName];
      cartItems.items.forEach((item) => {
        var row = {
          id: commons.newUUID(),
        };

        let fieldName = cartItems.fields[1].fieldName;
        let connectionFieldName = cartItems.fields[1].connectionFieldName;
        Vue.set(row, fieldName + "Id", item.id);
        Vue.set(row, fieldName, item.extension[connectionFieldName]);

        rows.push(row);
      });
    },
    async submit() {
      this.$emit("update:submitting", true);
      if (this.syncState) {
        await this.synchronize({});
      }
      this.$v.$touch();
      if (this.designMode && this.activityId === 'create' && this.isFormWithoutInformation) {
        this.$toasted.error('Before submitting the form, you will need to add at least one field');
        return;
      }
      if (this.$v.$invalid) {
        this.$emit("update:submitting", false);
        if (this.formValidationError) {
          this.formValidationError();
        } else {
          this.$toasted.global.invalidFormValidate();
        }
      } else {
        if (this.form && this.form.bds) {
          try {
            eval(this.form.bds);
          } catch (ex) {
            this.$toasted.error(ex);
            throw ex;
          }
        }
        this.$emit("submit", this.formData);
      }
    },
    async synchronize(payload) {
      payload.view = this.view;
      payload.polling = this.polling;
      payload.activity = this.selectedActivity;
      await this.$store.dispatch("synchronize", payload);
    },
    pollData(selectedActivity) {
      this.selectedActivity = selectedActivity;
      console.log("poll...");
      let vm = this;
      if (vm.polling) {
        console.log("clr poll" + vm.polling);
        clearInterval(vm.polling);
      }

      vm.polling = setInterval(() => {
        if (!vm.$store.getters.syncError) vm.synchronize({});
      }, 1500);
      this.$store.dispatch("polling", {
        polling: vm.polling,
      });
      console.log("crt poll: " + vm.polling);
    },
    onFormChange: _.debounce(async (vm) => {
      if (vm.$store.state.appliedChange) {
        vm.$store.dispatch("resetApplyChange");
      } else if (vm.sync) {
        await vm.synchronize({});
      }
    }, 500),
    reset() {
      this.$v.$reset();
      classificationStore.dispatch('setFormData', {});
    },
    async saveDesign() {
      try {
        clientStore.dispatch("setDesignModeLoading", true);
        let canvas = _.cloneDeep(canvasDesignStore.state.canvas);
        let activity = null;
        if (['create', 'edit', 'view', 'quickView'].indexOf(this.activityId) > -1) {
          activity = canvas.standardActivities.find((x) => x.id === this.activityId);
        } else {
          activity = canvas.activities.find((x) => x.id === this.activityId);
        }

        if (activity) {
          if (!activity.design) {
            activity.design = {};
          }
          activity.design.rows = _.cloneDeep(this.form.rows);
          commons.compactClassification(canvas);
          canvasDesign.compactDesignBeforeSave(canvas);
          canvasDesignStore.dispatch("updateVectorCanvas", canvas);
          const moduleResponse = await canvasDesignStore.dispatch("saveVector", {
            activityId: this.activityId
          });
          clientStore.dispatch("setDesignModeState", {
            success: true,
            updatedOn: moduleResponse.data.updatedDate
          });
        }
      } catch(err) {
        console.error(err);
        clientStore.dispatch("setDesignModeState", { error: true });
        this.$toasted.global.error({
          response: err.response,
          message: 'Failed to save design changes'
        });
      } finally {
        clientStore.dispatch("setDesignModeLoading", false);
      }
    },
    updateDesign: _.debounce(async function() {
      await this.saveDesign();
    }, 800)
  },
  watch: {
    formData: {
      deep: true,
      handler() {
        this.formChanged = true;
        this.onFormChange(this);
      },
    },
    users() {
      this.$store.dispatch("setUsers", { users: this.users });
    }
  },
  beforeCreate() {
    Vue.component("fts-form-layouter", FTSFormLayouter);
    Vue.component("fts-form", FTSForm);
  },
  created() {
    this.$set(this.comment, "attention", false);
  },
  mounted() {
    this.$nextTick(() => {
      this.$v.$reset();
    });
  },
  beforeDestroy() {
    clearInterval(this.polling);
  }
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-classification {
  .classification-comment {
    margin-top: 0.75rem;
  }
}
</style>